export default __webpack_public_path__ + "static/QE-Normal-48a412f9f91e6718790b6d170cb1762a.svg";